export default function unblockCustomersService($http) {
  return {
    unblock
  };

  function unblock(emails) {
    return $http.put('oc-api/operations/fraud/customers/unblock', {emails});
  }
}



// WEBPACK FOOTER //
// ./src/app/customers/unblock-customers/unblock-customers.service.js